document.documentElement.classList.add('js');

(function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileDrawer = document.querySelector('[data-mobile-drawer]');
  var siteHeader = document.querySelector('[data-site-header]');

  if (navToggle && mobileDrawer) {
    navToggle.addEventListener('click', function () {
      var isOpen = mobileDrawer.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('menu-open', isOpen);
    });

    mobileDrawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileDrawer.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      });
    });
  }

  window.addEventListener('scroll', function () {
    if (!siteHeader) return;
    if (window.scrollY > 18) {
      siteHeader.classList.add('is-scrolled');
    } else {
      siteHeader.classList.remove('is-scrolled');
    }
  }, { passive: true });

  var revealTargets = document.querySelectorAll('.reveal-on-scroll');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    revealTargets.forEach(function (target) {
      observer.observe(target);
    });
  } else {
    revealTargets.forEach(function (target) {
      target.classList.add('is-visible');
    });
  }
})();
